import Header from "../Header/Header";
import ReportSearchBar from "./ReportsSearchBar";

const ReportHeader = ({
  searchQuery,
  setSearchQuery,
  showLogo = true,
  showSearch = true,
  forceSignedOut = false,
}) => {
  const placeholder = "Search by party name or report number";

  return (
    <Header
      showLogo={showLogo}
      showSearch={showSearch}
      forceSignedOut={forceSignedOut}
      renderSearch={({ size }) => (
        <ReportSearchBar
          size={size}
          placeholder={placeholder}
          enableSuggestions={false}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      )}
    />
  );
};

export default ReportHeader;
